import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = { class: "card-header border-0" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "card-toolbar" }, null, -1)
const _hoisted_5 = {
  class: "card-body",
  style: {"padding-top":"0px","margin":"auto"}
}
const _hoisted_6 = { style: {"padding":"0 5px"} }
const _hoisted_7 = { style: {"padding":"0 5px"} }
const _hoisted_8 = { style: {"line-height":"25px","clear":"both"} }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { style: {"float":"left"} }, "类目", -1)
const _hoisted_10 = { style: {"float":"right"} }
const _hoisted_11 = {
  key: 0,
  style: {"line-height":"25px","clear":"both"}
}
const _hoisted_12 = { style: {"float":"left"} }
const _hoisted_13 = { style: {"float":"right"} }

import {MenuComponent} from "@/assets/ts/components";
import {setCurrentPageBreadcrumbs} from "@/core/helpers/breadcrumb";
import {onMounted, reactive, ref, watch} from "vue";
import {useStore} from "vuex";
import { useRoute, useRouter } from "vue-router";
import ApiService from "@/core/services/ApiService";
import Digram from "./components/Digram.vue";
import Summary from "./components/Summary.vue";
import Detail from "./components/Detail.vue";
import {parseTime} from '@/utils'
import {ElMessage} from 'element-plus';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
const route = useRoute();
const router = useRouter();
const apiUrl = 'report/product';
const filters = reactive({
  report_id: 0,  // 列表表头
  id: route.query['id'],  //输入商品主键ID
  weekly: '',  //周期，总共就8周
  goods_id: '', // 商品ID
  params: {
    zone: '',  // 区域
  },
  relation_goods: '', // 关联商品
});
const loading = ref<boolean>(false);
const info = reactive({
  fields: [] as any,
  data: {}
});
const chartData = ref<any[]>([]);
const chartField = ref<any[]>([]);

onMounted(() => {
  MenuComponent.reinitialization();
  setCurrentPageBreadcrumbs("report.product.productSingle", ["report.product.name", "report.product.productName"]);

  let date = new Date();
  date.setDate(date.getDate() - date.getDay() + 1); //定位到下周一
  date.setDate(date.getDate() - 1);
  let v = parseTime(date, "{y}{m}{d}");
  date.setDate(date.getDate() - 6);
  v = parseTime(date, "{y}{m}{d}") + '_' + v;
  filters.weekly = v;

  ApiService.get(apiUrl + '/' + route.query['id']).then(({data}) => {
    info.fields = data.fields;
    info.data = data.data;
    filters.goods_id = data.data.goods_id;
    filters.params.zone = data.data.zone;
    filters.relation_goods = data.data.r_goods;
    loading.value = true;
    setTimeout(() => {
      loading.value = false;
    }, 500);
  });
});

watch(route, (val) => {
  if (route.query['id']) {
    console.log('重新获取商品')
    ApiService.get(apiUrl + '/' + route.query['id']).then(({data}) => {
      info.fields = data.fields;
      info.data = data.data;
      filters.goods_id = data.data.goods_id;
      filters.params.zone = data.data.zone;
      filters.relation_goods = data.data.r_goods;
      loading.value = true;
      setTimeout(() => {
        loading.value = false;
      }, 500);
    });
  }
});

const dataAction = (data) => {
  chartData.value = JSON.parse(JSON.stringify(data)).reverse();
}
const fieldAction = (fields) => {
  chartField.value = fields;
}

return (_ctx: any,_cache: any) => {
  const _component_el_page_header = _resolveComponent("el-page-header")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_page_header, {
            content: '单品分析',
            onBack: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).back()))
          })
        ]),
        _hoisted_4
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_el_row, { justify: "center" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              ref: "imageDiv",
              span: 8,
              style: {"margin-right":"30px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_card, { "body-style": { padding: '5px', 'text-align': 'center' } }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_image, {
                      referrerpolicy: "no-referrer",
                      src: _unref(info).data.goods_img,
                      fit: "contain",
                      lazy: ""
                    }, null, 8, ["src"]),
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("span", null, _toDisplayString(_unref(info).data.goods_id), 1)
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 512),
            _createVNode(_component_el_col, {
              span: 8,
              style: {"margin-left":"30px"}
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(info).data.cat1_name
                  + (_unref(info).data.cat2_name ? " >> " + _unref(info).data.cat2_name : "")
                  + (_unref(info).data.cat3_name ? " >> " + _unref(info).data.cat3_name : "")
                  + (_unref(info).data.cat4_name ? " >> " + _unref(info).data.cat4_name : "")
                  + (_unref(info).data.cat5_name ? " >> " + _unref(info).data.cat5_name : "")), 1)
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(info).fields, (v) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: v.key
                    }, [
                      (v.is_display === true)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                            _createElementVNode("span", _hoisted_12, _toDisplayString(v.name), 1),
                            _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(info).data[v.field]), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_el_row, { gutter: 20 }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 12 }, {
          default: _withCtx(() => [
            _createVNode(Digram, {
              field: "imp_pv",
              data: chartData.value,
              fields: chartField.value
            }, null, 8, ["data", "fields"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 12 }, {
          default: _withCtx(() => [
            _createVNode(Digram, {
              field: "sale_num",
              data: chartData.value,
              fields: chartField.value
            }, null, 8, ["data", "fields"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(Summary, {
      filters: _unref(filters),
      title: "汇总数据",
      apiUrl: apiUrl + '/single_summary',
      reportId: 6,
      loading: loading.value,
      onTableData: dataAction,
      onTableField: fieldAction
    }, null, 8, ["filters", "apiUrl", "loading"]),
    _createVNode(Detail, {
      filters: _unref(filters),
      title: "关联分析",
      apiUrl: apiUrl + '/relation',
      reportId: 7,
      loading: loading.value,
      enableItemsPerPageDropdown: false
    }, null, 8, ["filters", "apiUrl", "loading"])
  ], 64))
}
}

})